import { Box } from "@mui/material";
import { AuthLayoutWrapper } from "./styled";
import { AuthImage } from "../../../assets";
import { AuthLayoutPropsType } from "../../../types/container.type";

export const AuthLayout: React.FC<AuthLayoutPropsType> = ({ children }) => {
    return (
        <AuthLayoutWrapper>
            <Box
                component={"div"}
                className="image-box"
            >
                <AuthImage />
            </Box>
            <Box
                component={"div"}
                className="form-box"
            >
                {children}
            </Box>
        </AuthLayoutWrapper>
    )
};
